import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=5c13c148&scoped=true"
import script from "./Steps.vue?vue&type=script&setup=true&lang=js"
export * from "./Steps.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Steps.vue?vue&type=style&index=0&id=5c13c148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13c148",
  null
  
)

export default component.exports